module.exports = __webpack_public_path__ + "static/media/Organisational Chart_Fund One_221123.88402f78.pdf";